/** Testi dell'aula in diretta: partecipante, console del relatore, regia, cruscotto della diretta. */
export const aula = {
  titolo: 'Aula',
  torna: 'Torna al percorso',
  inDiretta: 'IN DIRETTA',
  attesa: {
    titolo: 'Sala d’attesa',
    sottotitolo: 'La diretta parte all’orario previsto: resta su questa pagina, si aggiorna da sola.',
    inizioTra: 'Inizio previsto tra',
    inizioAlle: (ora: string) => `Inizio previsto alle ${ora}`,
    inRitardo: 'La diretta sta per cominciare: l’organizzatore avvia il flusso a momenti.',
    relatori: (nomi: string) => `Con ${nomi}`,
    soglia: (pct: number) => `Il test si apre con almeno il ${pct}% di presenza. Il conteggio parte con la diretta.`,
    prova: 'Prova il collegamento',
    provaInCorso: 'Verifica in corso',
    provaOk: (ms: number) => `Collegamento con Aulaviva: ${ms} ms. Puoi seguire senza problemi.`,
    provaLenta: (ms: number) => `Collegamento con Aulaviva: ${ms} ms. Se puoi, avvicinati al router o usa il cavo di rete.`,
    provaErrore: 'Non riusciamo a raggiungere Aulaviva. Controlla la connessione.',
    webrtc: 'Il browser supporta il video in diretta.',
    niente_webrtc: 'Questo browser non supporta WebRTC: vedrai il video con qualche secondo di ritardo.',
    giorni: (n: number) => `${n} g`,
    ore: (n: number) => `${n} h`,
    minuti: (n: number) => `${n} min`,
    secondi: (n: number) => `${n} s`,
  },
  chiusa: {
    titolo: 'L’aula non è ancora aperta',
    testo: (ora: string) => `L’aula si apre un’ora prima dell’inizio, alle ${ora}. Torna qui a quell’ora.`,
    nonConfermato: 'Non hai ancora confermato la partecipazione',
    nonConfermatoTesto: 'Conferma dal tuo percorso: ci vogliono due clic. Poi torna qui.',
    vaiAlWebinar: 'Vai al webinar',
  },
  sala: {
    titolo: 'Sei in sala',
    testo: 'Segui lo schermo della sala. Qui trovi le slide e puoi fare domande al relatore.',
  },
  terminata: {
    titolo: 'La diretta è terminata',
    testo: 'Grazie per aver partecipato. Il test si apre tra poco: ti avvisiamo qui e via email.',
    azione: 'Torna al percorso',
  },
  player: {
    connessione: 'Connessione in corso',
    ritardo: 'Stai seguendo con qualche secondo di ritardo.',
    terminato: 'La diretta è terminata.',
    errore: 'Il video non parte: controlla la connessione.',
    riprova: 'Riprova',
    cadutaRipresa: 'La connessione è caduta: i minuti già seguiti restano validi.',
  },
  domande: {
    etichetta: 'Fai una domanda al relatore',
    aiuto: 'La legge prima un moderatore, poi la passa al relatore. Non vedrà il tuo nome.',
    invia: 'Invia la domanda',
    inviata: 'Domanda inviata: la vedi qui sotto con il suo stato.',
    limite: 'Hai raggiunto il numero massimo di domande per questo webinar.',
    tue: 'Le tue domande',
  },
  assistenza: {
    apri: 'Serve aiuto?',
    inviata: 'Richiesta inviata: ti rispondiamo qui appena possibile.',
  },
  presenza: {
    segnaposto: 'Presenza: il conteggio parte con la diretta.',
  },
  relatore: {
    titolo: 'Console del relatore',
    torna: 'I miei webinar',
    schede: { flusso: 'Flusso', slide: 'Slide', domande: 'Domande' },
    anteprima: 'Anteprima della diretta',
    anteprimaTesto: 'È quello che vedono i partecipanti, con circa mezzo secondo di ritardo.',
    anteprimaAssente: 'Il flusso non è ancora arrivato: l’anteprima compare quando la regia trasmette.',
    trasmissione: 'Trasmissione dal tuo computer',
    trasmissioneTesto: 'Niente regia: trasmetti camera e microfono da qui. Usa un microfono esterno e il cavo di rete.',
    slide: 'Slide',
    slideTesto: 'Carica il PDF prima della lezione. Le frecce cambiano la pagina per tutti.',
    caricaSlide: 'Carica le slide (PDF)',
    caricaSlideAiuto: 'Un solo file PDF, fino a 50 MB. Sostituisce quello precedente.',
    slideCaricate: (n: number) => `Slide caricate: ${n} pagine.`,
    fileNonPdf: 'Il file deve essere un PDF.',
    fileTroppoGrande: 'Il file supera i 50 MB.',
    timer: 'In diretta da',
    nonIniziata: 'La diretta non è ancora iniziata: la avvia l’amministratore.',
    domandeTitolo: 'Domande dal pubblico',
    domandeTesto: 'Arrivano dal moderatore, senza il nome di chi le ha scritte. Leggile ad alta voce e rispondi in diretta.',
  },
  regia: {
    titolo: 'Regia',
    torna: 'Webinar',
    indirizzi: 'Indirizzi per l’encoder',
    indirizziTesto: 'SRT è la via principale; RTMP è la riserva. Configura entrambi i nodi nell’encoder: in caso di guasto basta cambiare destinazione.',
    srt: (nodo: string) => `SRT · ${nodo}`,
    rtmpUrl: (nodo: string) => `RTMP server · ${nodo}`,
    rtmpKey: 'RTMP stream key',
    chiave: 'Chiave del flusso',
    modalitaRelatore: 'Questo webinar è in modalità “dal computer del relatore”: la regia non invia il flusso. Gli indirizzi restano disponibili come riserva.',
    nodoAttivo: 'Nodo attivo',
    cambiaNodo: 'Passa al nodo',
    cambiaNodoTitolo: (nodo: string) => `Passare al nodo ${nodo}?`,
    cambiaNodoTesto: 'Prima cambia la destinazione nell’encoder, poi conferma qui: i player dei partecipanti si ricollegano al nuovo nodo entro pochi secondi.',
    cambiaNodoConferma: 'Sì, passa al nodo',
    nodoCambiato: 'Nodo cambiato: i partecipanti si stanno ricollegando.',
    slideTitolo: 'Slide',
    slideTesto: 'In alternativa al relatore, puoi cambiare la pagina da qui.',
    anteprima: 'Anteprima',
  },
  diretta: {
    titolo: 'Diretta',
    torna: 'Dettaglio del webinar',
    apri: 'Diretta',
    avvia: 'Avvia la diretta',
    avviaTitolo: 'Avviare la diretta?',
    avviaTesto: 'Da questo momento si contano i minuti di presenza. Il flusso deve essere già ricevuto.',
    avviaConferma: 'Sì, avvia',
    avviata: 'Diretta avviata.',
    chiudi: 'Chiudi la diretta',
    chiudiTitolo: 'Chiudere la diretta?',
    chiudiTesto: 'La presenza smette di contare, gli intervalli aperti si chiudono e il test si apre per 2 ore. Non si può riaprire.',
    chiudiConferma: 'Sì, chiudi',
    chiusa: 'Diretta chiusa.',
    flussoAssente: 'Il flusso non arriva al server video: controlla la regia o il relatore, poi riprova.',
    riapri: 'Riapri la diretta',
    riapriTitolo: 'Riaprire la diretta?',
    riapriTesto: 'Solo per le prove: il webinar torna a "pubblicato" e si azzerano inizio e fine effettivi. In produzione questa funzione non esiste.',
    riapriConferma: 'Sì, riapri',
    riaperta: 'Diretta riaperta: ora puoi avviarla di nuovo.',
    stato: 'Stato',
    iniziata: (ora: string) => `In diretta dalle ${ora}`,
    terminata: (ora: string) => `Terminata alle ${ora}`,
    nonIniziata: 'Non ancora iniziata',
    trasporti: 'Collegati',
    webrtc: (n: number) => `${n} in WebRTC`,
    hls: (n: number) => `${n} in HLS`,
    troppiHls: 'Più del 10% dei collegati è in HLS: controlla il nodo video e il TURN.',
    schede: { moderazione: 'Domande', assistenza: 'Assistenza', slide: 'Slide', nodi: 'Nodi' },
    inAttesa: (n: number) => `${n} in attesa`,
    moderazioneTesto: 'Inoltra le domande buone al relatore. Il relatore non vede chi le ha scritte.',
    filtroStato: 'Stato',
    tutti: 'Tutte',
    assistenzaTitolo: 'Richieste di assistenza',
    assistenzaTesto: 'Una richiesta, una risposta: rispondi e chiudi.',
    nessunaAssistenza: 'Nessuna richiesta aperta.',
    rispondi: 'Rispondi',
    rispostaTitolo: (nome: string) => `Risposta a ${nome}`,
    risposta: 'Risposta',
    rispostaAiuto: 'Breve e pratica: cosa deve fare adesso.',
    inviaRisposta: 'Invia e chiudi',
    risposto: 'Risposta inviata.',
    anteprima: 'Apri l’anteprima',
    nodi: 'Nodi video',
    nodoAttivo: 'Nodo attivo',
    stati: { aperta: 'Aperta', risposta: 'Risposta', chiusa: 'Chiusa' } as const,
    statiDomanda: { in_attesa: 'In attesa', inoltrata: 'Inoltrate', risposta: 'Risposte', scartata: 'Scartate' } as const,
  },
};
